import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';

@Component({
  selector: 'app-phrclinicalnotes',
  templateUrl: './phrclinicalnotes.component.html',
  styleUrls: ['./phrclinicalnotes.component.scss'],
  providers: [AppService, IceNavService]
})
export class PhrclinicalnotesComponent implements OnInit {

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService) {
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Notes", {}, true, "");
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }
}
